import { integrationStats } from "@/mocks/integrationsData";

export function IntegrationStatsBar() {
  const stats = [
    {
      label: "Connected Sources",
      value: integrationStats.connectedSources,
      icon: "ri-plug-line",
      color: "bg-green-100 text-green-600",
    },
    {
      label: "Leads Today via API",
      value: integrationStats.leadsTodayViaApi,
      icon: "ri-database-2-line",
      color: "bg-indigo-100 text-indigo-600",
    },
    {
      label: "Failed Webhooks",
      value: integrationStats.failedWebhooks,
      icon: "ri-error-warning-line",
      color: "bg-red-100 text-red-600",
    },
    {
      label: "Last Sync",
      value: integrationStats.lastSync,
      icon: "ri-refresh-line",
      color: "bg-amber-100 text-amber-600",
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {stats.map((stat) => (
        <div
          key={stat.label}
          className="bg-white border border-[#e5e7eb] rounded-xl p-4 flex items-center gap-4"
        >
          <div
            className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${stat.color}`}
          >
            <i className={`${stat.icon} text-lg`} />
          </div>
          <div className="min-w-0">
            <p className="text-xs text-[#6b7280] truncate">{stat.label}</p>
            <p className="text-xl font-bold text-[#111827] mt-0.5">{stat.value}</p>
          </div>
        </div>
      ))}
    </div>
  );
}